import GenericToast from 'Components/GenericToast';
import OtpErrorToast from 'Components/OtpErrorToast';
import React from 'react';

export const flowToastMapType = {
  SUCCESS_TOAST: 'SUCCESS_TOAST',
  ERROR_TOAST: 'ERROR_TOAST',
  WRONG_OTP_ERROR_TOAST: 'OTP_ERROR_TOAST',
  WRONG_DOUBLE_OTP_ERROR_TOAST: 'DOUBLE_OTP_ERROR_TOAST',
  LAST_ATTEMPT_OTP_ERROR_TOAST: 'LAST_ATTEMPT_OTP_ERROR_TOAST',
  LAST_ATTEMPT_DOUBLE_OTP_ERROR_TOAST: 'LAST_ATTEMPT_DOUBLE_OTP_ERROR_TOAST',
  GENERATED_NEW_OTP: 'GENERATED_NEW_OTP',
  GENERATED_NEW_DOUBLE_OTP: 'GENERATED_NEW_DOUBLE_OTP',
  INFO_TOAST: 'INFO_TOAST'
};

export const flowToastMap = {
  [flowToastMapType.SUCCESS_TOAST]: <GenericToast severity='success' />,
  [flowToastMapType.ERROR_TOAST]: <GenericToast severity='error' />,
  [flowToastMapType.INFO_TOAST]: <GenericToast severity='info' />,
  [flowToastMapType.WRONG_OTP_ERROR_TOAST]: <OtpErrorToast severity="error" type='WRONG' />,
  [flowToastMapType.WRONG_DOUBLE_OTP_ERROR_TOAST]: <OtpErrorToast severity="error" type='WRONG_DOUBLE' />,
  [flowToastMapType.LAST_ATTEMPT_OTP_ERROR_TOAST]: <OtpErrorToast severity="error" type='LAST' />,
  [flowToastMapType.LAST_ATTEMPT_DOUBLE_OTP_ERROR_TOAST]: <OtpErrorToast severity="error" type='LAST_DOUBLE' />,
  [flowToastMapType.GENERATED_NEW_OTP]: <OtpErrorToast severity="success" type='NEW' />,
  [flowToastMapType.GENERATED_NEW_DOUBLE_OTP]: <OtpErrorToast severity="success" type='NEW_DOUBLE' />,
};

export default flowToastMap;
